module.exports = __webpack_public_path__ + "files/179fe3fa5d445150b2d55777ca4a2f68.png";